export default __webpack_public_path__ + "static/media/rail-riser-flat.8b0af384.svg";